(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsFilterBarAppliedFilter', rmsFilterBarAppliedFilter);

    function rmsFilterBarAppliedFilter(lodash) {
        return {
            restrict: 'E',
            scope: {
                filter: '='
            },
            controller: rmsFilterBarAppliedFilterCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/applied-filter',
            link: rmsFilterBarAppliedFilterLink
        };


        function rmsFilterBarAppliedFilterLink(scope, elem) {

            elem.on('click', '.remove-applied-filter', function () {
                if (lodash.get(scope.vm.filter, 'rules.can_remove', true) === true) {
                    scope.vm.removeAppliedFilter();
                    scope.$apply();
                }
            });

            scope.$on('$destroy', () => {
                elem.off('click', '.remove-applied-filter');
            });


        }
    }

    function rmsFilterBarAppliedFilterCtrl(MainFilterBarService, $scope, $filter, $timeout, lodash) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = $scope.$parent.vm.filterBarIdentifier;
            MainFilterBarService.sync(vm, vm.filterBarIdentifier); // this gives vm.filterBarService();

            vm.constructQueryText = constructQueryText;
            vm.removeAppliedFilter = removeAppliedFilter;
            vm.onPopoverClose = onPopoverClose;
            vm.onPopoverOpen = onPopoverOpen;
            vm.applyFilter = applyFilter;
            vm.cancel = cancel;
            vm.validateFilterClass = validateFilterClass;

            init();
            // will show the popover when the applied filter is added into the list.
            $timeout(function () {
                if (!vm.filter._hide_on_load) {
                    vm.togglePopover();
                }
            });
        }

        function init() {
        }

        function constructQueryText() {
            const label = $filter('filterBarAppliedFilter')(vm.filter, vm.filterBarService().getLabels());
            const can_remove = lodash.get(vm.filter, 'rules.can_remove', true) && !lodash.get(vm.filter.settings, 'required', false);
            const remove_filter_icon = can_remove ? '<i class="fa fa-times position-left remove-applied-filter"></i>' : '';
            return `<span class="label default  cursor-pointer">${label} ${remove_filter_icon}</span>`;
        }

        function removeAppliedFilter() {
            vm.filterBarService().removeApplied(vm.filter);
        }

        function applyFilter() {
            const result = vm.filterBarService().applyFilter(vm.filter, vm.options);
            if (result.success) {
                vm.errorMessage = null;
                vm.togglePopover();
            } else {
                vm.errorMessage = result.message;
            }
        }

        function cancel() {
            vm.errorMessage = null;
            vm.togglePopover();
        }

        function onPopoverClose() {
            vm.options = [];
            // reset temp data;
        }

        function onPopoverOpen() {
            vm.options = vm.filterBarService().getFilterTypeOption(vm.filter);
        }

        function validateFilterClass() {
            if (vm.filter.incomplete) {
                return 'has-issue';
            }
        }


    }
})();
